// Central registry of data-testid values used across the portal.
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const TID = {
  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  otpInput: "otp-input",
  otpSubmit: "otp-submit-button",
  otpResend: "otp-resend-button",
  otpBack: "otp-back-button",

  // Layout
  sidebar: "app-sidebar",
  sidebarToggle: "sidebar-toggle-button",
  themeToggle: "theme-toggle-button",
  logoutButton: "logout-button",
  mobileMenuButton: "mobile-menu-button",

  // Dashboard
  dashboard: "dashboard-page",
  approveClinic: "approve-clinic-button",
  holdClinic: "hold-clinic-button",
  rejectClinic: "reject-clinic-button",

  // Clinics
  clinicsPage: "clinics-page",
  clinicSearch: "clinic-search-input",
  clinicRow: "clinic-row",
  clinicDetail: "clinic-detail-page",
  updateStatus: "update-status-button",

  // Revenue / Subscribers
  revenuePage: "revenue-page",
  subscribersPage: "subscribers-page",
  subscriberSearch: "subscriber-search-input",

  // Demo requests
  demoPage: "demo-requests-page",
  demoStatusSelect: "demo-status-select",

  // Approvals
  approvalsPage: "approvals-page",
};
